import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { NEUTRAL_300 } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 24px 16px;
  gap: 16px;
  overflow-y: auto;
`

export const SummaryAmountWrapper = styled.div`
  width: 100%;
`

export const DetailsWrapper = styled.div`
  width: 100%;
`

export const DetailsTitleWrapper = styled.div`
  margin-bottom: 8px;
  margin-top: 14px;
`

export const DetailsTitle = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${NEUTRAL_300};
`

export const ButtonWrapper = styled.div`
  padding: 16px;
  background-color: white;
  padding-bottom: 32px;
`
